import { useEffect, useState } from 'react';

import { QueryObserver, useQueryClient } from '@tanstack/react-query';
import { useTariffSummaryQueryKey } from 'products/tariffSummary/hooks/useTariffSummaryQueryKey.ts';
import { TafiffSummary } from 'products/tariffSummary/Inventory/api/tariffSummaryApi.ts';

export const useTariffSummaryQueryData = () => {
  const queryKey = useTariffSummaryQueryKey();

  const [tariffSummary, setTariffSummary] = useState<TafiffSummary | undefined>();
  const queryClient = useQueryClient();
  useEffect(() => {
    const observer = new QueryObserver<TafiffSummary>(queryClient, {
      queryKey,
    });

    return observer.subscribe((result) => {
      const queryResult = result.data;
      setTariffSummary(queryResult);
    });
  }, [queryKey]);

  return tariffSummary;
};
